var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('oeamtc-select',{attrs:{"value":_vm.valueIndex,"options":_vm.zoneOptions,"disabled":_vm.disabled,"aria-name":"Ziel"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }